export function getParticipantLayoutRoomConfig(participantLayoutConfig = {}) {
  const forceEnabled = !!participantLayoutConfig.forceEnabled;
  const defaultEnabled = forceEnabled || !!participantLayoutConfig.defaultEnabled;

  return {
    defaultEnabled,
    forceEnabled
  };
}
